// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"_93c71d0"};